<ng-template #templateSelectedResources let-item="item">
    <span [attr.class]="item?.resourceType == 'host' ? 'badge badge-blue' : 'badge badge-light-blue'">{{ item?.resourceType }}</span>
    {{ item?.name }}
</ng-template>

<ng-template #templateDisplayResources let-item='item'>
    <span class="badge badge badge-light-blue">vm</span>
    {{ item.name }}
</ng-template>

<ng-template #templateDisplayResourcesWhenEmpty>
    <clr-control-helper slot="displayWhenEmpty">Type a resource name</clr-control-helper>
</ng-template>

<ng-template #templateDisplayResourcesWhenErrors>
    <clr-control-error slot="displayWhenError">There was an error</clr-control-error>
</ng-template>

@for (side of sides; track side) {
<h4>{{ side == 'source' ? 'Source' : 'Destination' }}</h4>

<clr-radio-container clrInline>
  <clr-radio-wrapper>
    <input type="radio" clrRadio name="{{ side }}Mode-{{ radioGroupsSuffix }}" required value="any"
           [ngModel]="networkRule.modeOf(side)" (ngModelChange)="setMode(side, $event)" />
    <label>Any {{ side }}</label>
  </clr-radio-wrapper>
  <clr-radio-wrapper>
    <input type="radio" clrRadio name="{{ side }}Mode-{{ radioGroupsSuffix }}" required value="specific"
           [ngModel]="networkRule.modeOf(side)" (ngModelChange)="setMode(side, $event)" />
    <label>Specific {{ side }}s</label>
  </clr-radio-wrapper>
</clr-radio-container>

@if (networkRule.modeOf(side) == "specific") {
  <div class="endpoints">
    <p class="endpoints-help">
      A flow matches this side as soon as it matches one of the resources, resource types, apps groups or networks
      below.
      @if (networkRule.endpointsOf(side).length == 0) {
        <span class="endpoints-warning">Nothing is listed yet: this side matches no flow.</span>
      }
    </p>

    <h5>Resources</h5>
    <app-apps-groups-combobox
        [selectedItems]="resourcesBySide[side]"
        (selectedItemsChange)="resourcesChanged(side, $event)"
        [itemsGenerator]="fetchVms"
        [templateSelectedItems]="templateSelectedResources"
        [templateDisplayItems]="templateDisplayResources"
        [templateDisplayWhenEmpty]="templateDisplayResourcesWhenEmpty"
        [templateDisplayWhenErrors]="templateDisplayResourcesWhenErrors"
        [itemsField]="'name'"
        [singleItemSelection]="false"
    >
    </app-apps-groups-combobox>

    <h5>Resource types</h5>
    <clr-checkbox-container clrInline>
      @for (resourceType of resourceTypes; track resourceType.type) {
        <clr-checkbox-wrapper>
          <input type="checkbox" clrCheckbox name="{{ side }}ResourceType-{{ resourceType.type }}-{{ radioGroupsSuffix }}"
                 [ngModel]="isResourceTypeSelected(side, resourceType.type)"
                 (ngModelChange)="setResourceTypeSelected(side, resourceType.type, $event)" />
          <label>{{ resourceType.label }}</label>
        </clr-checkbox-wrapper>
      }
    </clr-checkbox-container>

    <h5>Apps groups</h5>
    <div class="endpoints-list">
      @for (endpoint of endpointsOfKind(side, 'apps_group'); track endpoint) {
        @let description = describeEndpoint(endpoint);
        <app-apps-group-ref [endpoint]="endpoint" [description]="description">
          <cds-icon shape="times-circle" solid class="endpoint-remove" title="Remove this apps group"
                    (click)="removeEndpoint(side, endpoint)"></cds-icon>
        </app-apps-group-ref>
      } @empty {
        <span class="endpoints-empty">No apps group</span>
      }
    </div>
    <!-- Picked as the apps groups page lists them: a file, then a group of it -->
    <div class="endpoints-add">
      <cds-icon shape="node-group" class="apps-groups-icon" title="Apps groups, as defined in the apps groups page"></cds-icon>
      <select class="clr-select" name="{{ side }}AppsGroupsFile-{{ radioGroupsSuffix }}"
              [ngModel]="selectedFileBySide[side]" (ngModelChange)="fileSelected(side, $event)">
        <option [ngValue]="undefined" disabled>apps groups file</option>
        @for (file of appsGroupsResolver?.files ?? []; track file) {
          <option [ngValue]="file">{{ file }}</option>
        }
      </select>
      <span class="path-separator">›</span>
      <select class="clr-select" name="{{ side }}AppsGroup-{{ radioGroupsSuffix }}"
              [disabled]="selectedFileBySide[side] == undefined"
              [(ngModel)]="selectedAppGroupBySide[side]">
        <option [ngValue]="undefined" disabled>apps group</option>
        @for (appGroup of appsGroupsOfSelectedFile(side); track appGroup.name) {
          <option [ngValue]="appGroup.name">{{ appGroup.name }}</option>
        }
      </select>
      <button type="button" class="btn btn-sm btn-outline" [disabled]="selectedAppGroupBySide[side] == undefined"
              (click)="addAppGroup(side)">Add</button>
    </div>

    <h5>Networks</h5>
    <div class="endpoints-list">
      @for (endpoint of endpointsOfKind(side, 'network'); track endpoint) {
        <span class="label label-blue">
          {{ endpoint.address }}
          <cds-icon shape="times-circle" solid class="endpoint-remove" title="Remove this network"
                    (click)="removeEndpoint(side, endpoint)"></cds-icon>
        </span>
      } @empty {
        <span class="endpoints-empty">No network</span>
      }
    </div>
    <div class="endpoints-add">
      <input class="clr-input" name="{{ side }}Network-{{ radioGroupsSuffix }}" placeholder="10.0.0.12 or 10.0.0.0/24"
             [(ngModel)]="networkBySide[side]" (keydown.enter)="addNetwork(side)" />
      <button type="button" class="btn btn-sm btn-outline" [disabled]="(networkBySide[side] ?? '').trim() == ''"
              (click)="addNetwork(side)">Add</button>
    </div>
  </div>
}
}

<h4>Protocol</h4>

<clr-radio-container clrInline>
  <clr-radio-wrapper>
    <input type="radio" clrRadio name="protocolOptions-{{ radioGroupsSuffix }}" required value="any" [(ngModel)]="networkRule.protocolMode" />
    <label>Any protocol</label>
  </clr-radio-wrapper>
  <clr-radio-wrapper>
    <input type="radio" clrRadio name="protocolOptions-{{ radioGroupsSuffix }}" required value="specific" [(ngModel)]="networkRule.protocolMode" />
    <label>Specific protocol</label>
  </clr-radio-wrapper>
</clr-radio-container>

@if(networkRule.protocolMode == "specific") {
<clr-input-container>
  <label>Protocol</label>
  <input clrInput name="protocol-{{ radioGroupsSuffix }}" placeholder="Protocol value" [(ngModel)]="networkRule.protocol" />
</clr-input-container>
}

<h4>Port</h4>

<clr-radio-container clrInline>
  <clr-radio-wrapper>
    <input type="radio" clrRadio name="portOptions-{{ radioGroupsSuffix }}" required value="any" [(ngModel)]="networkRule.portMode" />
    <label>Any port</label>
  </clr-radio-wrapper>
  <clr-radio-wrapper>
    <input type="radio" clrRadio name="portOptions-{{ radioGroupsSuffix }}" required value="custom" [(ngModel)]="networkRule.portMode" />
    <label>Custom port(s)</label>
  </clr-radio-wrapper>
</clr-radio-container>

@if(networkRule.portMode == "custom") {
<clr-input-container>
  <label>Port</label>
  <input clrInput name="port-{{ radioGroupsSuffix }}" [(ngModel)]="networkRule.port" />
</clr-input-container>
}

<h4>Direction</h4>

<clr-radio-container clrInline>
  <clr-radio-wrapper>
    <input type="radio" clrRadio name="directionOptions-{{ radioGroupsSuffix }}" required value="n/a" [(ngModel)]="networkRule.direction" />
    <label>N/A</label>
  </clr-radio-wrapper>
  <clr-radio-wrapper>
    <input type="radio" clrRadio name="directionOptions-{{ radioGroupsSuffix }}" required value="1" [(ngModel)]="networkRule.direction" />
    <label>Port is on source</label>
  </clr-radio-wrapper>
  <clr-radio-wrapper>
    <input type="radio" clrRadio name="directionOptions-{{ radioGroupsSuffix }}" required value="0" [(ngModel)]="networkRule.direction" />
    <label>Port is on destination</label>
  </clr-radio-wrapper>
</clr-radio-container>

<h4>Two ways</h4>

<clr-checkbox-container>
  <clr-checkbox-wrapper>
    <input type="checkbox" clrCheckbox value="twoWays" name="twoWays-{{ radioGroupsSuffix }}" [(ngModel)]="networkRule.twoWays" />
    <label>Add inverse rule</label>
  </clr-checkbox-wrapper>
</clr-checkbox-container>
